module.exports = __webpack_public_path__ + "files/a6c92e98c8fc957080d4db60220f25c3.svg";